import React from 'react';
import ComponentWrapper from '../../layout/ComponentWrapper';
import { StudyDesignOverview, StudyDesignArms, StudyCopyBlock } from '../index';
import styled from 'styled-components';

const StyledComponent= styled(ComponentWrapper)`
[class*='StudyDesign__MultiFlowWrapper']{
    div:first-child, div:nth-child(2) {
        margin-top: 0px;
    }
}
`;

const MTNBC = () => (

    <StyledComponent>
        <StudyDesignOverview title="Study Overview" description="A Phase 3, Multicenter, Open-Label, Randomized, Active-Controlled Trial in Unresectable Locally Advanced or Metastatic TNBC With Tumor PD-L1 Expression (CPS ≥10)<sup>2</sup>"
         data={[
            [
                {
                    title: 'Patient Eligibility Criteria',
                    description: `
                    <p><strong>Key Inclusion Criteria<strong></p>
                        <ul>
                            <li>Unresectable locally advanced or metastatic TNBC</li>
                            <li>Tumor PD-L1 expression (CPS ≥10) according to the PD-L1 IHC 22C3 pharmDx assay</li>
                            <li>No previous treatment with systemic therapy for advanced disease</li>
                            <li>≥6 months between completion of systemic breast cancer therapy (chemotherapy with or without a PD-1 or PD-L1 inhibitor and/or radiotherapy in early-stage TNBC) or surgery, whichever occurred last, and first local or distant recurrence</li>
                        </ul>
                    <p><strong>Key Exclusion Criteria<strong></p>
                        <ul>
                            <li>Patients with active autoimmune disease that required systemic therapy within 2 years of treatment or a medical condition that required immunosuppression were ineligible</li>                       
                        </ul>
                    <p><strong>Stratification Factors<strong></p>
                        <ul>
                            <li>Treatment-free interval (<i>de novo</i> vs recurrent disease within 6 to 12 months from completion of treatment in the curative setting vs recurrent disease occurring >12 months from completion of treatment in the curative setting)</li>
                            <li>Geographic region (US/Canada/Western Europe vs Rest of World)</li>
                            <li>Prior exposure to PD-1 or PD-L1 inhibitor (yes vs no)</li>                          
                        </ul>
                        
                    `,
                    type: 'box-gradient',
                    colspan: 2
                }
            ],
            [
                {
                    title: 'Randomized <strong>(1:1)</strong> N=443',
                    colspan: 2
                }
            ],
            [
                {
                    type: 'arrow-gray',
                },
                {
                    type: 'arrow-gray',
                }
            ],
        ]} />

        <StudyDesignArms
            title="Study Arms"
            arms={[
                {
                    data: [
                        [
                            {
                                title: `
                                    <div class="h7">KEYTRUDA + SG-hziy (n=221)</div>
                                `,
                                description: [
                                    {
                                        text: `KEYTRUDA 200 mg IV Q3W on day 1 of each 21-day cycle`,
                                        textCenter: true
                                    },
                                    {
                                        text: `<strong>SG-hziy</strong> <br />(10 mg/kg IV on days 1 and 8 of each 21-day cycle)`,
                                        conditional: 'and',
                                        textCenter: true
                                    },
                                ],
                                type: 'box-multi-color-green'
                            }
                        ],
                    ]
                },
                {
                    data: [
                        [
                            {
                                title: `
                                    <div class="h7">KEYTRUDA + chemotherapy (n=222)</div>
                                `,
                                description: [
                                    {
                                        text: `KEYTRUDA 200 mg IV Q3W on day 1 of each 21-day cycle`,
                                        textCenter: true
                                    },
                                    {
                                        text: `<strong>Paclitaxel</strong> <br />(90 mg/m<sup>2</sup> IV on days 1, 8, and 15 of each 28-day cycle)`,
                                        conditional: 'and',
                                        textCenter: true
                                    },
                                    {
                                        text: `<strong>nab-paclitaxel</strong> <br />(100 mg/m<sup>2</sup> IV on days 1, 8, & 15 of each 28-day cycle)`,
                                        conditional: 'OR',
                                        textCenter: true
                                    },
                                    {
                                        text: `<strong>gemcitabine</strong> <br />(1000 mg/m<sup>2</sup> IV`,
                                        conditional: 'OR',
                                        textCenter: true
                                    },
                                    {
                                        text: `<strong>carboplatin</strong> <br />AUC 2 mg/mL/min IV on days 1 & 8 of each 21-day cycle)`,
                                        conditional: 'and',
                                        textCenter: true
                                    },

                                ],
                                type: 'box-multi-color-gray'
                            }
                        ],
                    ]
                }
            ]}
            textDescription={
            <>
                <ul>
                    <li>Treatment beyond BICR-verified disease progression per RECIST 1.1 was permitted if the patient was clinically stable and considered to be deriving clinical benefit by the investigator. </li>
                    <li>Assessment of tumor status was performed every 8 weeks for the first 18 months, and every 12 weeks thereafter.</li>
                    <li>Crossover to sacituzumab govitecan-hziy monotherapy was offered following disease progression and study treatment discontinuation.</li>
                </ul>
            </>}
        />

        <StudyCopyBlock
            title="Primary Efficacy Outcome Measure"
            description={`
                <ul>
                    <li>PFS<sup>b</sup></li>
                </ul>
            `}
        />
        <StudyCopyBlock
            title="Additional Efficacy Outcome Measures"
            description={`
                <ul>
                    <li>OS</li>
                    <li>ORR<sup>b</sup></li>
                </ul>

            `}
            footnotes={[
                {
                    label: "b.",
                    text: "Assessed by BICR using RECIST 1.1."
                }
            ]}
            definitions={`
            AUC = area under the curve; IV = intravenously.
            `}
        />


    </StyledComponent>
);

export default MTNBC;